<div class="login_page">
  <!-- Toast notification -->
  <c-toaster placement="top-end" position="absolute" class="p-3">
    <c-toast
      #toast
      [visible]="errorMessage"
      class="login_page__toast"
      color="danger"
    >
      <div class="d-flex border border-danger">
        <c-toast-body>
          <span>{{ errorMessage }}</span>
        </c-toast-body>
        <button
          aria-label="close toast"
          cButtonClose
          class="me-2 m-auto"
          (click)="toast.visible = false"
        ></button>
      </div>
    </c-toast>
  </c-toaster>

  <!-- Background decorations -->
  <div class="login_page__bg_decoration login_page__bg_decoration--1"></div>
  <div class="login_page__bg_decoration login_page__bg_decoration--2"></div>
  <div class="login_page__bg_decoration login_page__bg_decoration--3"></div>

  <!-- Login Card -->
  <div class="login_page__card">
    <div class="login_page__card__left">
      <div class="login_page__card__left__content">
        <!-- Logo -->
        <div class="login_page__logo">
          <img src="/assets/img/logo-white.png" alt="ShareWave" />
        </div>

        <h1 class="login_page__title">Bienvenido</h1>
        <p class="login_page__subtitle">
          Inicia sesión para acceder a tu cuenta
        </p>

        <!-- Form -->
        <form
          cForm
          [formGroup]="loginGroup"
          (ngSubmit)="onSubmit()"
          class="login_page__form"
        >
          <div class="login_page__form__group">
            <label for="login_email" class="login_page__form__label">
              <svg cIcon name="cilUser"></svg>
              <span>Email</span>
            </label>
            <div class="login_page__form__input_wrapper">
              <input
                id="login_email"
                autoComplete="email"
                cFormControl
                placeholder="ejemplo@correo.com"
                formControlName="email"
                class="login_page__form__input"
              />
            </div>
          </div>

          <div class="login_page__form__group">
            <label for="login_password" class="login_page__form__label">
              <svg cIcon name="cilLockLocked"></svg>
              <span>Contraseña</span>
            </label>
            <div class="login_page__form__input_wrapper">
              <input
                id="login_password"
                autoComplete="current-password"
                cFormControl
                placeholder="••••••••"
                [type]="showPassword ? 'text' : 'password'"
                formControlName="password"
                class="login_page__form__input"
              />
              <button
                type="button"
                class="login_page__form__input_toggle"
                (click)="showPassword = !showPassword"
                [attr.aria-label]="
                  showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'
                "
              >
                @if (showPassword) {
                  <!-- Eye Off (Slash) Icon -->
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="icon-eye"
                  >
                    <path
                      d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
                    ></path>
                    <line x1="1" y1="1" x2="23" y2="23"></line>
                  </svg>
                } @else {
                  <!-- Eye Icon -->
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="icon-eye"
                  >
                    <path
                      d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                    ></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                }
              </button>
            </div>
          </div>

          <button
            class="login_page__form__btn"
            type="submit"
            [disabled]="loadingState"
          >
            @if (loadingState) {
              <span
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              <span>Ingresando...</span>
            } @else {
              <span>Iniciar sesión</span>
              <svg cIcon name="cilArrowRight"></svg>
            }
          </button>
        </form>
      </div>
    </div>

    <!-- Right Panel -->
    <div class="login_page__card__right">
      <div class="login_page__card__right__content">
        <div class="login_page__card__right__decoration"></div>
        <img
          src="/assets/img/logo.png"
          alt="ShareWave"
          class="login_page__card__right__logo"
        />
        <!-- h2 class="login_page__card__right__title">ShareWave</h2 -->
        <p class="login_page__card__right__text">
          ShareWave es una herramienta digital online para eventos y campañas de
          marketing que genera credenciales digitales, versátiles y originales
          para ser compartidas en redes sociales en solo 3 pasos.
        </p>
        <p class="login_page__card__right__slogan">Sube. Genera. Comparte.</p>
        <a
          [href]="landingUrl"
          class="login_page__card__right__btn"
          target="_blank"
        >
          Consigue una demo aquí
          <svg cIcon name="cilArrowRight"></svg>
        </a>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <p class="login_page__footer">
    ShareWave versión {{ version }}<br />
    © 2022-{{ currentYear }}
    <a [href]="developerUrl" target="_blank">Content Media</a>
  </p>
</div>
